import "./App.css";
import ViewResume from "./Pages/ViewResume/ViewResume";
import ResumesList from "./Components/ResumeList/ResumeList";
import Dashboard from "./Pages/Dashboard/Dashboard";
import Login from "./Pages/Login/Login";
import Register from "./Pages/Register/Register";
import { Routes, Route } from "react-router-dom";
import Profile from "./Pages/Profile/Profile";
import "./App.css";
import PersonalInfo from "./Pages/CreateResume/PersonalInfo";
import Education from "./Pages/CreateResume/Education";
import ProfessionalExperience from "./Pages/CreateResume/ProfessionalExperience";
import Skills from "./Pages/CreateResume/Skills";
import ProfessionalSummary from "./Pages/CreateResume/ProfessionalSummary";
import DashboardHr from "./Pages/Dashboard/DashboardHr";
import "react-toastify/dist/ReactToastify.css";
import EmployeeResumeList from "./Components/ResumeList/EmployeeResumeList";
import CandidateResumeList from "./Components/ResumeList/CandidateResumeList";
import ViewResumeCandidate from "./Pages/ViewResume/ViewResumeCandidate";
import CVAnalyzerApp from "./CVAnalyzerApp/CVAnalyzerApp";
import ProtectedRoute from "./ProtectedRoute";
import Employee from "./Pages/Dashboard/components/employee";

function App() {
  return (
    <div className="App">
      {/* <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/personalInfo" element={<PersonalInfo />} />
        <Route path="/education" element={<Education />} />
        <Route path="/professionalExperience" element={<ProfessionalExperience />} />
        <Route path="/skills" element={<Skills />} />
        <Route path="/professionalSummary" element={<ProfessionalSummary />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dashboardHr" element={<DashboardHr />} />
        <Route path="/resumes" element={<ResumesList />} />
        <Route path="/employeeResumeList" element={<EmployeeResumeList />} />
        <Route path="/candidateResumeList" element={<CandidateResumeList />} />
        <Route path="/viewResume/:userId" element={<ViewResume />} />
        <Route path="/viewResumeCandidate/:candidateId" element={<ViewResumeCandidate />} />


      </Routes> */}
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Protected Routes */}
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/personalInfo"
          element={
            <ProtectedRoute>
              <PersonalInfo />
            </ProtectedRoute>
          }
        />
        <Route
          path="/education"
          element={
            <ProtectedRoute>
              <Education />
            </ProtectedRoute>
          }
        />
        <Route
          path="/professionalExperience"
          element={
            <ProtectedRoute>
              <ProfessionalExperience />
            </ProtectedRoute>
          }
        />
        <Route
          path="/skills"
          element={
            <ProtectedRoute>
              <Skills />
            </ProtectedRoute>
          }
        />
        <Route
          path="/professionalSummary"
          element={
            <ProtectedRoute>
              <ProfessionalSummary />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboardHr"
          element={
            <ProtectedRoute>
              <DashboardHr />
            </ProtectedRoute>
          }
        />
        <Route
          path="/resumes"
          element={
            <ProtectedRoute>
              <ResumesList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employeeResumeList"
          element={
            <ProtectedRoute>
              <EmployeeResumeList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboardHR/employee/:id"
          element={
            <ProtectedRoute>
              <Employee />
            </ProtectedRoute>
          }
        />
        <Route
          path="/candidateResumeList"
          element={
            <ProtectedRoute>
              <CandidateResumeList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/viewResume/:userId"
          element={
            <ProtectedRoute>
              <ViewResume />
            </ProtectedRoute>
          }
        />
        <Route
          path="/viewResumeCandidate/:candidateId"
          element={
            <ProtectedRoute>
              <ViewResumeCandidate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cvanalyzer"
          element={
            <ProtectedRoute>
              <CVAnalyzerApp />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
